import moment from "moment";
import groupBy from "lodash/groupBy";

export const formatDate = ({ date, format = "llll" }) =>
  moment(date).format(format);

export const formatUserName = (name) => name.split("#")[0];

export const getUsername = () => {
  const congitoKey = window.localStorage.cognitoKey;
  return window.localStorage[`${congitoKey}.LastAuthUser`] || "";
};

export const isJson = (item) => {
  item = typeof item !== "string" ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  if (typeof item === "object" && item !== null) {
    return true;
  }

  return false;
};

//due to a limitation with the json editor library it really doesn't
//like us having the item "children" and tries to add a "relationship" reference to it
//this results in a fatal error when an array called children gets a string appended to it and it
//then tries to add a property "relationship" to that string, this is a work around
//that will probably be with us forever
export const removeChildrenProperty = (item) => {
  const stringified = JSON.stringify(item);
  if (!stringified) {
    return {};
  }
  return JSON.parse(stringified.replace(/children/gm, "child"));
};

export const readdChildrenProperty = (item) => {
  if (!item) {
    return {};
  }
  const stringified = JSON.stringify(item);
  return JSON.parse(stringified.replace(/child/gm, "children"));
};

export const groupEventsByMonth = (events) => {
  return Object.entries(
    groupBy(events, (i) => moment(i.event_date).format("YYYY MMMM"))
  )
    .map((i) => ({ date: i[0], events: i[1] }))
    .sort((a: any, b: any) => b.date - a.date);
};
